<hyperkit-dialog
  class="hyperkit-component"
  [headerText]="submitted ? 'We\'ll be in touch!' : 'Premium Content'"
>
  <div>
    @if (!submitted) {
      <div class="body">
        <img
          style="margin-right: 5px"
          width="32"
          height="32"
          src="/assets/img/icons/cyborg-premium.png"
        />
        <p>
          Through Intel 471's paid subscription model, you gain unlimited access
          to Hunt Content. If you would like pricing information or to inquire
          about a proof of concept, please tell us a little bit more about your
          project, and we will be in touch shortly.
        </p>
        <form [formGroup]="unlockForm" (ngSubmit)="onUnlock()">
          <div class="row">
            <div class="col-12">
              @if (error) {
                <hyperkit-error [error]="error"></hyperkit-error>
              }
              <label>Message</label>
              <textarea
                maxlength="150"
                placeholder="Tell us a little bit about why you'd like to access this content."
                formControlName="message"
              ></textarea>
            </div>
          </div>
          <button
            themeColor="primary"
            size="large"
            type="submit"
            [disabled]="!unlockForm.valid"
            kendoButton
          >
            Request Content
          </button>
        </form>
      </div>
    }
    @if (submitted) {
      <div class="submitted body">
        <p>
          Keep an eye on your inbox for next steps to access this premium
          content.
        </p>
      </div>
    }
  </div>
</hyperkit-dialog>
